import * as React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { injectIntl } from 'react-intl-next';
import type { WrappedComponentProps } from 'react-intl-next';
import { getCanAdministerJIRA, getAgentForPortal } from 'state/selectors/user';
import { FieldBase } from 'view/common/fields/field-base';
import messages from './messages';

export interface Props {
    id: string;
}

export interface ConnectedProps {
    canAdministerJIRA: boolean;
    agentForPortal: boolean;
}

export class UnknownField extends React.Component<Props & WrappedComponentProps & ConnectedProps> {
    render() {
        const { id, intl, canAdministerJIRA, agentForPortal } = this.props;
        if (canAdministerJIRA || agentForPortal) {
            return <FieldBase htmlFor={id} label={intl.formatMessage(messages.unknownField, { id })} />;
        }
        return null;
    }
}

const selector = createSelector(getCanAdministerJIRA, getAgentForPortal, (canAdministerJIRA, agentForPortal) => ({
    canAdministerJIRA,
    agentForPortal,
}));
export default connect(selector, {})(injectIntl(UnknownField));
